import { ConfigProvider, Layout, message, Col, Row, Pagination, Input } from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import zhCN from 'antd/lib/locale/zh_CN'
import selfCss from './vod-list.module.less'
import Cookies from 'js-cookie'
import './vod-list.module.css'
import * as constants from '../../constants/constants';
import { ReactComponent as eyeSvg }   from '../../static/image/module/eyegreen.svg'
import Icon from '@ant-design/icons'
import {checkUserLogin} from "../common/user-center/user-info";

import { ArrowRightOutlined, SearchOutlined} from '@ant-design/icons';


import Feedback from '../common/feedback-help/feedback'
import { sendHttpPostRequest } from '../../api/http-request'

const eyeIcon = (props:any) => (<Icon component={eyeSvg} {...props} />)

interface Props {
  lecture:any,
}
/**
 * VodList
 * 视频列表
 */
export const VodList: React.FC<Props> = (props) => {
  
  const [bannerList, setBannerList] = useState([] as any[]);  // 当前显示的结果页

  const [lectureListResult, setLectureResult] = useState([] as any[]);  // 当前显示的结果页
  const [resultSum, setResultSum] = useState(0);  // 搜索返回的结果数
  const [totalCount, setTotalCount] = useState(0);  // 总数
  const [onlineCount, setOnlineCount] = useState(0);  // 上架的数量


  const [queryContent, setQueryContent] = useState('');  // 记录搜索串

  const order = useRef('');  // 排序升序降序
  const order_by = useRef('');  // 排序列
  const page = useRef(1);  // 记录当前的页数
  const pageSize = useRef(12);  // 记录当前每页展示数量

  const [isLogin, setIsLogin] = useState(false) //是否登录
  
  const exampleQueries = ["人工智能","大数据","机器学习","数据科学","深度学习"]


  useEffect(() => {
    sendHttpPostRequest(
      'account/api/query_teacher_authenticate',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
      },
      (response: any) => {
        if (response.is_ok == true) {
          setIsLogin(true)
        }
      } );
    queryLectureList();

  }, [])


      /**
     * 查询讲座列表
     */
       const queryLectureList = () => {
        sendHttpPostRequest(
            'video/api/user_query_lecture_list/',
            {
                sessionid: Cookies.get("sessionid"),    
                query: queryContent,
                page: page.current,
                pagesize: pageSize.current,
                order: order.current,
                order_by: order_by.current,
            },
            (response: any) => {
                message.destroy();
                /*if (response.code == -100) {
                    // 未登录
                    window.location.href = '/login?next=lecture';
                } else */
                 if (response.is_ok == true) {
                    // 成功
                    setLectureResult(response.query_list);
                    setResultSum(response.total_sum);
                    setTotalCount(response.total_count);
                    setOnlineCount(response.online_count);
                } else if (response.code == -501) {
                    // 权限不足
                    window.location.href = '/login?next=lecture';
                }/*else {
                    message.error(response.message);
                }*/
            }
        
        )
    }
    



 const onVodCardClick = (lecture_id: string, event: any) => {
    event.preventDefault();
    if (!checkUserLogin()) {
      document.getElementById("show-login-modal")!.click();
    } else {
      window.open('lecture-vod?lecture_id=' + lecture_id);
    }
 }
  

     //点击了搜索按钮
     const onSearchBtn = (event: any) => {
      page.current = 1;
      setQueryContent(event.target.value)
      queryLectureList();
  }
  //页码和页数发生了变化
  const onPageChange = (newPage: number, newPageSize?: number | undefined) => {
        page.current = newPage ? newPage : 1;
        if (newPageSize) {
            pageSize.current = newPageSize;
        }
       queryLectureList();
  }



  return (

      <Layout style={{minHeight: 'calc(100vh - 156px)',backgroundColor: 'rgb(249, 250, 251)'}}>

        <section className={selfCss.headerSection}>

          <div className={selfCss.headerDivWrapper}>
            <div className={selfCss.headerDiv}>

              <div className={selfCss.headerTitle} >
                    数智技术前沿讲座系列
              </div>

              <div className={selfCss.headerDescription}>
                  邀请行业专家分享最新技术趋势与实践经验，助力您把握数智时代机遇
              </div>

            </div>
          </div>

          <div className={selfCss.zhuangshiWrapper1}>
             <div className={selfCss.zhuangshiDiv1}></div>
          </div>
           

          <div className={selfCss.zhuangshiWrapper2}>
             <div className={selfCss.zhuangshiDiv2}></div>
          </div>

          <div className={selfCss.zhuangshiWrapper3}>
             <div className={selfCss.zhuangshiDiv3}></div>
          </div>


        </section>


        <div style={{marginLeft:'auto', marginRight:'auto', width:1280}}> 

          <section className={selfCss.searchSection} >
            <div style={{textAlign:'center'}}>
              <Input
                onPressEnter={onSearchBtn} 
                placeholder="搜索讲座主题、讲师姓名..." 
                className={selfCss.searchInput}
                prefix={<SearchOutlined />}
                value={queryContent}
                onChange={(e)=>{setQueryContent(e.target.value)}}
                />
            </div>

            <div style={{textAlign:'center', display:'flex', justifyContent:'center'}}>
              <div style={{margin:'16px 0 0', textAlign:'left', width:768}}>

                <span style={{color:'#6b7280', fontSize:16}}>热门搜索</span>: 
                {exampleQueries?.map((query,index)=>(
                  <span onClick={()=>{setQueryContent(query) }} className={selfCss.queryItem} key={index} > #{query}</span>
                ))}
              </div>
            </div>



            

          </section>

          <section className={selfCss.resultSection}>

            <div className={selfCss.vodList}>

              <div style={{display:'flex', alignItems:'center',  textAlign:'left', color:'#333', fontSize:32, fontWeight:700, margin:'0 0 32px'}}>最新讲座 <span style={{borderRadius:999,fontSize:14, fontWeight:500,padding:'4px 12px', marginLeft:12, color:'#07c160', background:'#E6F7EF'}}> 共{totalCount}场</span></div>

              <Row gutter={[24, 24]} wrap={true} justify="start">
                {lectureListResult?.map((lecture) => {
                  return (
                    <Col key={lecture.id} span={6}>                       
                      <div
                        className={selfCss.vodCard}                      
                      >

                        <div className={selfCss.cardCoverDiv}>
                              <div className={selfCss.viewLabelDiv}>
                                <span
                                className={selfCss.viewLabel}
                                >
                                <Icon component={eyeIcon}/>  {lecture?.view_cnt}次观看
                                </span>

                      
                            </div>
                            <img
                              src={ lecture?.cover?.startsWith("http") ? lecture?.cover : constants.BACKEND_URL + lecture?.cover}
                              height={'100%'}
                              width={'100%'}
                              style={{borderTopRightRadius: 12, borderTopLeftRadius: 12}}
                            />

                        </div>

                        <div className={selfCss.cardContentDiv}>
                            <div className={selfCss.vodTitle}>{lecture.title}</div>
                            <div className={selfCss.vodTeacher}>{lecture?.teacher}{' '} {lecture?.teacher_title}</div>
                            <div  style={{textAlign:'right'}}  >  <span className={selfCss.cardLookBtn} onClick={onVodCardClick.bind(this, lecture.id)} > 查看详情 <ArrowRightOutlined /> </span></div>

                        </div>

                        
                        
                      </div>                                
                    </Col>
                  )
                })}
              </Row>
              </div>

              <ConfigProvider locale={zhCN}>

              <div  style={{ marginBottom: 30, paddingTop: 30 }}
                className={'css.pagination'} >
              <Pagination
              defaultCurrent={1}
              current={page.current}
              total={resultSum}
              defaultPageSize={pageSize.current}
              hideOnSinglePage={true}
              onChange={onPageChange}
              showSizeChanger={false}       
              />
              </div>
              </ConfigProvider>


          </section>

        </div>

       

  
          <Feedback />
          
        </Layout>

  )

}

export default VodList


